'use client';
import { createContext, useContext } from 'react';

import { DataFetcher } from '../repositories/fetcher/DataFetcher';
import { MobilfunkRepository } from '../repositories/mobilfunkRepository.ts';
import { VaxRepository } from '../repositories/vaxRepository.ts';

export interface NocoDbContextData {
	mobilfunkRepository: MobilfunkRepository;
	vaxRepository: VaxRepository;
}

export const RepositoryContext = createContext<NocoDbContextData>(undefined!);
RepositoryContext.displayName = 'RepositoryContext';

export function generateRepository(): NocoDbContextData {
	const dataFetcher = new DataFetcher();

	return <NocoDbContextData>{
		mobilfunkRepository: new MobilfunkRepository(dataFetcher),
		vaxRepository: new VaxRepository(dataFetcher),
		// Add ritualAbuseRepository, ... here
	};
}

export const useRepositories = () => useContext(RepositoryContext);
